


































































































































































import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

import PrescriptionTemplateParameter from '@/components/prescription-templates/form/parameter-template.vue';
import PrescriptionTemplatePatientResume from '@/components/prescription-templates/resume/patient-resume.vue';
import PrescriptionFormInfos from '@/components/prescription/form/infos.vue';
import PrescriptionFormSaveArea from '@/components/prescription/form/save-area.vue';
import PrescriptionBase from '@/components/prescription/prescription-base.vue';
import PrescriptionProductsList from '@/components/prescription/products-list.vue';
import TemplateFormBase from '@/components/prescription/template-form-base.vue';
import UiAutocompleClientsSubsidiaries from '@/components/UI/autocomplete-clients-subsidiaries.vue';
import InputMoney from '@/components/UI/input-money.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';

import * as service from '@/services/prescription-templates';

import { decimalFormat } from '@/helpers/decimalFormat';
import { toNumber } from '@/helpers/toNumber';
import { TemplateParmDTO } from '@/interfaces/prescription-template';
import PrescriptionTemplateModel from '@/models/prescription-template-model';
import {
  ADULT, ADULT_PESO, NEWBORN, NEWBORN_PESO, PATIENT_NEWBORN_TYPES, PATIENT_TYPES, PEDIATRIC, PEDIATRIC_PESO
} from '@/settings/consts/patient';
import { PrescriptionValidation } from '@/settings/consts/prescription-validation';
import { PATTERN, PROFILE } from '@/settings/consts/template-types';

@Component({
  components: {
    PermissionAuth,
    TemplateFormBase,
    PrescriptionFormInfos,
    PrescriptionProductsList,
    PrescriptionFormSaveArea,
    PrescriptionTemplatePatientResume,
    UiAutocompleClientsSubsidiaries,
    InputMoney,
    PrescriptionTemplateParameter,
  },
})
export default class PrescriptionTemplateForm extends PrescriptionBase {
  @Prop()
  public isEdit: boolean = false;
  @Prop()
  public editItem: any;
  public item: PrescriptionTemplateModel = new PrescriptionTemplateModel();
  public rules: any = {
    name: [(v) => !!v || 'Digite um titulo para o template'],
    code: [(v) => !!v || 'Digite um código para o template'],
    volume: [(v) => (!!v && toNumber(v) > 0) || 'Digite o volume final.',],
    patientType: [(v) => !!v || 'Selecione um tipo de paciente'],
  };

  public patientTypes: any[] = [];
  public listaIndexacao: any[] = [];
  public patientNewbornTypes: any[] = [];
  public patientNewbornType: string = NEWBORN;
  public templateTypes: any = {};
  modelsMulticomp: any[] = [];
  modelsMulticompLoading: boolean;
  idsMulticompSelec: number[] = [];


  @Watch('item.unidadesCliente')
  public onChangeData(val: any): void {
    if(this.prescriptionState == PrescriptionValidation.IMPEDITIVE.key)
      return;
    if (val.length === 0
    || this.item.produtos.length === 0 )
      this.prescriptionState = PrescriptionValidation.INVALID.key;
    else this.prescriptionState = PrescriptionValidation.OK.key;
  }

  @Watch('prescriptionState')
  public onChangeStatePrescription(val: any): void {
    if (
      val === PrescriptionValidation.OK.key &&
      this.item.unidadesCliente.length === 0
    )
      this.prescriptionState = PrescriptionValidation.INVALID.key;
  }

  get canShowProducts(): boolean {
    return (
      !!this.item.nome &&
      !!this.item.volumeDesejado &&
      !!this.item.paciente
    );
  }

  @Watch('editItem')
  public onEditItemChanges(val: any) {
    this.resetPrescription();
    this.setItem(val);
  }

  public onChangePatientType(): void {
    if (this.item.tipoPaciente !== this.patientNewbornType) {
      this.item.termo = null;
    }

    if(this.item.tipoPaciente ==  PEDIATRIC){
      this.item.paciente.peso = PEDIATRIC_PESO.toString();
    }else if(this.item.tipoPaciente ==  ADULT){
      this.item.paciente.peso  = ADULT_PESO.toString();
    }else if(this.item.tipoPaciente ==  NEWBORN){
      this.item.paciente.peso  = NEWBORN_PESO.toString();
    }

  }

  public beforeMount(): void {
    this.getPatientTypes();
    this.getTemplateTypes();
    this.loadMulticompOptions();
  }

  public onChangeVolume(): void {
    this.onChangeMLDia();
  }

  public calcQSPWater(desejado, digitado): string {
    return this.formatValue(Math.max(desejado - digitado, 0));
  }

  public formatValue(value: number): string {
    return decimalFormat(value);
  }

  public newPrescription() {
    this.onEditItemChanges(null);
  }

  public saveItem(): void {
    this.item.padroesTemplate = this.listaIndexacao;

    this.$refs.form.validate();
    if (!this.form.valid) {
      return;
    }

    this.loader.start('Salvando registro...');
    const payload = new TemplateParmDTO();
    payload.load(this.item);    

    service.savePrescriptionTemplate(payload).subscribe((data) => {
        this.loader.stop();
        this.$refs.form.resetValidation();
        this.$emit('save');
      }, error => {
        this.showToastApiError(error);
        this.loader.stop();
      });
  }

  public closeForm(): void {
    const closeAction = () => {
      setTimeout(() => {
        this.$refs.form.resetValidation();
      }, 100);
      this.$emit('close');
    };
    this.dialog.show(
      'error',
      'Sair sem salvar',
      'Deseja sair sem salvar as alterações?',
      'Cancelar',
      '',
      'Sair',
      closeAction,
    );
  }

  private getTemplateTypes(): void {
    this.templateTypes = {
      profile: {
        value: PROFILE,
        label: 'Perfil',
      },
      pattern: {
        value: PATTERN,
        label: 'Padrão',
      },
    };
  }

  private getPatientTypes(): void {
    this.patientTypes = Object.keys(PATIENT_TYPES).map((type) => {
      return {
        value: type,
        label: PATIENT_TYPES[type],
      };
    });
    this.patientNewbornTypes = Object.keys(PATIENT_NEWBORN_TYPES).map(
      (type) => {
        return {
          value: type,
          label: PATIENT_NEWBORN_TYPES[type],
        };
      },
    );
  }

  loadMulticompOptions() {
    this.modelsMulticompLoading = true;
    service.getMultiCompTemplateOptions().subscribe(res => {
      this.modelsMulticomp = res;
      this.modelsMulticompLoading = false;
    }, error => {
      this.modelsMulticompLoading = false;
      this.showToastApiError(error);
    })
  }

  private setItem(val: any): void {
    if (!val) {
      this.item = new PrescriptionTemplateModel();
      return;
    }

    const editPrescription = {
      ...val,
    };

    this.item = new PrescriptionTemplateModel(editPrescription);
    let tpPaciente = (this.item.tipoPaciente as any);
    this.item.tipoPaciente = tpPaciente && tpPaciente.id ? tpPaciente.id : tpPaciente;
    this.receivedProducts = this.item.produtos;
    this.listaIndexacao = this.item.padroesTemplate;
    this.onChangeVolume();
  }

  public isPrescricao(): boolean {
    return false;
  }
}
